<template>
  <!-- 跳转课程列表页面组件 -->
  <div class="capacity-body">
    <img class="Study-list-img" @click="toList()" src="@a/Study-list.png" alt />
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    /*
     *@Description: 跳转列表页面
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-27 15:49:04
     */
    toList() {
      this.$router.push({
        path: "/list",
        query: {
          cid: this.$route.query.cid
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.capacity-body{
  max-width: 750px;
  width: 100%;
  position: fixed;
  z-index: 777;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
}
.Study-list-img {
  position: fixed;
  right: 37px;
  bottom: 360px;
  width: 96px;
  height: 96px;
}
</style>